// extracted by mini-css-extract-plugin
module.exports = {"channel-loading":"index_channel-loading_9nJvG"};